import L from 'leaflet';

export function distanceToSegment(point, segment) {
    const [x, y] = point;
    const [[x1, y1], [x2, y2]] = segment;

    const dx = x2 - x1;
    const dy = y2 - y1;

    // Если отрезок вырожден в точку
    if (dx === 0 && dy === 0) {
        return Math.hypot(x - x1, y - y1);
    }

    // Вычисляем параметр проекции
    const t = ((x - x1) * dx + (y - y1) * dy) / (dx * dx + dy * dy);

    let nearestX, nearestY;

    if (t < 0) {
        // Ближайшая точка - начало отрезка
        nearestX = x1;
        nearestY = y1;
    } else if (t > 1) {
        // Ближайшая точка - конец отрезка
        nearestX = x2;
        nearestY = y2;
    } else {
        // Проекция на отрезок
        nearestX = x1 + t * dx;
        nearestY = y1 + t * dy;
    }

    // Расстояние до ближайшей точки
    return Math.hypot(x - nearestX, y - nearestY);
}

export function distancePointToSegment(point, segment) {
    const [x, y] = point;          // Исследуемая точка [x, y]
    const [[x1, y1], [x2, y2]] = segment;  // Отрезок [[x1,y1], [x2,y2]]

    // Вектор AB отрезка
    const ax = x2 - x1;
    const ay = y2 - y1;

    // Если отрезок вырожден в точку
    if (ax === 0 && ay === 0) {
        return Math.hypot(x - x1, y - y1);
    }

    // Вектор AP от точки A до исследуемой точки
    const apx = x - x1;
    const apy = y - y1;

    // Скалярное произведение AB · AP
    const dot = ax * apx + ay * apy;
    
    // Квадрат длины отрезка AB
    const lenAB2 = ax ** 2 + ay ** 2;

    // Параметр проекции (0 = A, 1 = B)
    const t = Math.max(0, Math.min(1, dot / lenAB2));

    // Ближайшая точка на отрезке
    const closestX = x1 + ax * t;
    const closestY = y1 + ay * t;

    // Расстояние до ближайшей точки
    return Math.hypot(x - closestX, y - closestY);
}


export function removeDuplicatesByKey(arr, key) {
    // Проверка входных данных
    if (!Array.isArray(arr)) return [];
    if (typeof key !== 'string') return arr;
  
    const seen = new Map();
    return arr.filter(item => {
      // Проверяем наличие ключа в объекте
      if (!item || !item.hasOwnProperty(key)) return true; // или можно выбросить ошибку
      
      const value = item[key];
      // Сохраняем первое уникальное вхождение
      if (!seen.has(value)) {
        seen.set(value, true);
        return true;
      }
      return false;
    });
  }

export function aimToObject(map, host) {
    console.log(map.getPanes())
    console.log('aimToObject', host)
    map.fire('overlaylayerchange', {name: host.type, state: true})
    if (host.coords) {
        map.setView(host.coords, 18, { duration: 1, animate: false })
    } else {
        map.setView([
            host.x_y_coord.split(' ')[1],
            host.x_y_coord.split(' ')[0],
        ], 18, { duration: 1, animate: false })
    }
    map.eachLayer(function (layer) {
        layer.closeTooltip()
    })
    setTimeout(() => {
        map.closePopup()
        map.eachLayer(function (layer) {
            if (layer.options.data === host.fid && layer.options.type === host.type) {
                layer.openTooltip()
                addPulseMarker(map, layer)
            }
        })
    }, 1000)
}


export function addPulseMarker(map, layer) {
    
    console.log('addPulseMarker', layer)
    const icon = new L.DivIcon({
        className: 'pulse-animation',
        iconSize: [70, 70],
        html: `<div style='position:absolute; bottom: 0; display:flex; margin-left: 0px; margin-bottom: 0px'>
                <svg width="70" height="70" viewBox="0 0 100 100">
                    <circle id="select" r="50" cx="50" cy="50" fill="#00A2E8" />
                </svg>
            </div>`
    })
    const marker = L.marker(layer.getLatLng(), {
        icon: icon,
        pane: 'shadowPane'
    })
    marker.addTo(map)
    setTimeout(() => {
        marker.remove()
    }, 6000)
    
}